import { Box, Typography } from "@mui/material";

/**
 * NotFoundPage - Component that renders a page indicating that page was not found
 * @component
 */
const NotFoundPage = () => {
    return (
        <Box className="content-container tw-flex tw-min-h-[100dvh] tw-w-full tw-items-center tw-justify-center tw-bg-slate-100 tw-p-4 dark:tw-bg-slate-950">
            <Box className="content tw-relative tw-w-full tw-max-w-xl tw-overflow-hidden tw-rounded-2xl tw-bg-gtr-teal-dark tw-p-8 tw-text-center tw-text-white tw-shadow-none sm:tw-p-12">
                <Box className="tw-absolute -tw-right-16 -tw-top-20 tw-h-56 tw-w-56 tw-rounded-full tw-bg-gtr-green/20" aria-hidden="true" />
                <Box className="tw-absolute -tw-bottom-24 -tw-left-16 tw-h-56 tw-w-56 tw-rounded-full tw-bg-gtr-teal/50" aria-hidden="true" />
                <Box className="tw-relative tw-z-10 tw-flex tw-flex-col tw-items-center tw-gap-3">
                    <Typography className="!tw-font-prometo !tw-text-7xl !tw-font-black !tw-leading-none !tw-text-white sm:!tw-text-8xl">404</Typography>
                    <Box className="tw-h-1 tw-w-16 tw-rounded-full tw-bg-gtr-green" />
                    <Typography className="!tw-font-prometo !tw-text-xl !tw-font-semibold !tw-text-white sm:!tw-text-2xl">
                        Página não encontrada.
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default NotFoundPage;
